import action from './assets/promoIcons/action.svg';
import discount from './assets/promoIcons/discount.svg';
import maternalCapital from './assets/promoIcons/maternalCapital.svg';
import militaryMortgage from './assets/promoIcons/militaryMortgage.svg';
import mortgage from './assets/promoIcons/mortgage.svg';
import { TPromoType } from '../../types/promo';

export const PROMO_ICON = new Map<TPromoType, string>([
  ['discount', discount],
  ['militaryMortgage', militaryMortgage],
  ['bonus', action],
  ['mortgage', mortgage],
  ['maternalCapital', maternalCapital],
  ['installment', mortgage],
]);
